/* dsp-delivery.js — estimated US delivery window: today + min..max business days (Sat/Sun skipped).
   Writes "Sep 25 – Oct 2" into [data-dsp-delivery] and reveals its [data-dsp-delivery-row]. */
(function () {
  'use strict';
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }
  function run() {
    var fmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    document.querySelectorAll('[data-dsp-delivery]').forEach(function (el) {
      var min = parseInt(el.dataset.minDays, 10) || 5;
      var max = parseInt(el.dataset.maxDays, 10) || 10;
      if (max < min) max = min;
      var today = new Date();
      el.textContent = fmt.format(addBusinessDays(today, min)) + ' – ' + fmt.format(addBusinessDays(today, max));
      var row = el.closest('[data-dsp-delivery-row]');
      if (row) row.removeAttribute('hidden');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
